<template>
  <div id="notification" class="pa-2 text-center">
    <v-slide-y-reverse-transition>
      <div v-if="unableToPublish">
        <v-chip
          class="unable-to-publish text--secondary"
          color="white"
          @click="$refs.publisherErrorDialog.toggleDialog()"
        >
          <Icon
            :width="24"
            class="mr-3"
            :color="'rgba(0,0,0,.54)'"
            :icon="'video-off'"
          />
          {{$t('session.notifications.message1')}}
          <v-btn
            color="primary"
            text
            small
            class="ml-2"
            rounded
          >
            {{$t('session.notifications.seeMore')}}
          </v-btn>
        </v-chip>
        <PublisherErrorDialog
          ref="publisherErrorDialog"
          @openChat="$parent.toggleChatContainer(true)"
        />
      </div>
      <div v-else-if="!mediaAccess">
        <v-chip
          class="permission-denied text--secondary"
          color="white"
          @click="$refs.permisionDenied.toggleDialog()"
        >
          <Icon
            :width="24"
            class="mr-3"
            :color="'rgba(0,0,0,.54)'"
            :icon="'microphone-off'"
          />
          <Icon
            :width="24"
            class="mr-3"
            :color="'rgba(0,0,0,.54)'"
            :icon="'video-off'"
          />
          {{$t('session.notifications.message2')}}
          <v-btn
            color="primary"
            text
            small
            class="ml-2"
            rounded
          >
            {{$t('session.notifications.seeMore')}}
          </v-btn>
        </v-chip>
        <PermissionDenied
          ref="permisionDenied"
          :handlerButtonText="$t('session.RETRY')"
          :persistent="false"
          @handler="$widget.reTry()"
          @openChat="$parent.toggleChatContainer(true)"
        />
      </div>
    </v-slide-y-reverse-transition>
  </div>
</template>

<script>
/* eslint-disable */
import { Component, Vue } from 'vue-property-decorator'

@Component({
  components: {
    PermissionDenied: () => import(/* webpackPrefetch: true */ '@/views/permissions/components/PermissionDenied.vue'),
    PublisherErrorDialog: () => import(/* webpackPrefetch: true */ '@/views/session/resources/PublisherErrorDialog.vue'),
    Icon: () => import(/* webpackPrefetch: true */ '@/components/Icon.vue')
  },
  props: {
    mediaAccess: {
      type: Boolean,
      default: true
    },
    unableToPublish: {
      type: Boolean,
      default: false
    }
  }
})
export default class Notifications extends Vue {}
</script>

<style>
#notification {
  position: absolute;
  z-index: 4;
  bottom: 0px;
  width: 100%;
}
</style>
